import { useState } from "react";
import useEventListener from "./useEventListener";

export default function useHover(reference: React.MutableRefObject<HTMLDivElement | HTMLParagraphElement>) {
  const [hovered, setHovered] = useState(false);
  useEventListener("mouseover", () => setHovered(true), reference.current);
  useEventListener("mouseout", () => setHovered(false), reference.current);
  return hovered;
}
